import React from 'react'
import clsx from 'clsx'

export interface ReplyButtonProps {
  onClick?: () => void
  disabled?: boolean
  children?: React.ReactNode
  locked?: boolean
}

export const ReplyButton: React.FC<ReplyButtonProps> = ({ onClick, disabled, children, locked }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick} className={clsx('button small font-semibold icon-button',
        {
          'pro-steel-grey-600': disabled === true || locked === true,
          disabled: disabled === true,
          'pro-blue-400-outline': locked === false && disabled === false
        }
      )}
    >
      {children}
      {locked === true && (
        <i className='fa fa-lock-keyhole' aria-hidden='true' />
      )}
    </button>
  )
}
